import {TextField, Typography, makeStyles, Checkbox, FormControlLabel, Button, FormControl, RadioGroup, InputLabel, OutlinedInput, Grid, MenuItem} from "@material-ui/core";
import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Radio from "@material-ui/core/Radio";
import _ from 'lodash';
import { useToken } from "../../../../utilities/hooks";

const useStyles = makeStyles((theme) => ({
    dashBetween: {
        alignSelf: 'center',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2)
    }
}));

const HIGH_THRESHOLD = 9999
const LOW_THRESHOLD = 0

function QuickRouting(props) {
    const {t} = useTranslation('mapManagement');
    const {handleStartBatchRoute} = props
    const classes = useStyles()
    const tokenContents = useToken();

    const userUS = tokenContents.userUS;

    const [partialCheck, setPartialCheck] = useState(false);
    const [lowThreshold, setLowThreshold] = useState(LOW_THRESHOLD);
    const [highThreshold, setHighThreshold] = useState(HIGH_THRESHOLD);
    const [selectedRange, setSelectedRange] = useState(false);
    const [selectedServiceList, setSelectedServiceList] = useState(false);
    const [rangeStart, setRangeStart] = useState();
    const [rangeEnd, setRangeEnd] = useState();
    const [serviceNumbers, setServiceNumbers] = useState();
    const [routeType, setRouteType] = useState(1);

    return (
        <div style={{paddingTop: 16}}>
            <Grid
                container
                alignItems="center"
                justify="center"
                justifyContent="flex-end"
                style={{marginBottom: 20}}
            >
                <Grid item xs={12}>
                    <TextField
                        select
                        value={routeType}
                        variant="outlined"
                        onChange={(event) => setRouteType(event.target.value)}
                        fullWidth
                    >
                        <MenuItem value={1} >{t('original_planning_method')}</MenuItem>
                        {/* Only for CA for now */}
                        {
                            (!userUS) &&
                            <MenuItem value={2}>{t('vrp_planning_method')}</MenuItem>
                        }
                        <MenuItem value={3}><div>{t('hopper_planning_method')}</div></MenuItem>
                    </TextField>
                </Grid>
            </Grid>
            <form style={{display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex'}}>
                    <TextField
                        type='number'
                        size='small'
                        label={t('low_threshold')}
                        variant='outlined'
                        defaultValue={LOW_THRESHOLD}
                        onChange={(event) => setLowThreshold(event.target.value)}
                    />
                    <Typography className={classes.dashBetween}> - </Typography>
                    <TextField
                        type='number'
                        size='small'
                        label={t('high_threshold')}
                        variant='outlined'
                        defaultValue={HIGH_THRESHOLD}
                        onChange={(event) => setHighThreshold(event.target.value)}
                    />
                </div>
                <FormControlLabel
                    control={
                        <Checkbox
                            color='secondary'
                            onChange={() => {
                                setPartialCheck(!partialCheck)
                            }}
                        />
                    }
                    label={t('Replace_partially_saved_routes')}
                />
            </form>
            <Grid
                container
                alignItems="center"
                justify="center"
                justifyContent="flex-end"
                style={{flexGrow: 1}}
            >
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color='secondary'
                                id='quickrouting-selectedrange-checkbox'
                                onChange={() => {
                                    setSelectedRange(!selectedRange)
                                }}
                            />
                        }
                        label={t('service_range')}
                    />
                    {selectedRange &&
                        <div style={{display: 'flex'}}>
                            <TextField
                                size='small'
                                label={t('range_start')}
                                id='quickrouting-rangestart-textfield'
                                variant='outlined'
                                onChange={(event) => setRangeStart(event.target.value)}
                            />
                            <Typography className={classes.dashBetween}> - </Typography>
                            <TextField
                                size='small'
                                label={t('range_end')}
                                variant='outlined'
                                onChange={(event) => setRangeEnd(event.target.value)}
                                id='quickrouting-rangeend-textfield'
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color='secondary'
                                onChange={() => {
                                    setSelectedServiceList(!selectedServiceList)
                                }}
                                id='quickrouting-selectedservicelist-checkbox'
                            />
                        }
                        label={t('service_list')}
                    />
                    {selectedServiceList &&
                        <div>
                            <TextField
                                size='small'
                                fullWidth
                                label={t('service_list')}
                                style={{marginBottom: '10px'}}
                                variant='outlined'
                                onChange={(event) => setServiceNumbers(event.target.value)}
                                id='quickrouting-servicelist-textfield'
                            />
                        </div>
                    }
                </Grid>
            </Grid>
            <Button
                variant='contained'
                color='secondary'
                fullWidth
                onClick={() => handleStartBatchRoute({
                    lowThreshold,
                    highThreshold,
                    partialCheck,
                    selectedServiceList,
                    selectedRange,
                    rangeStart,
                    rangeEnd,
                    serviceNumbers,
                    routeType
                })}
            >
                Start Making Routes
            </Button>
        </div>
    )
}

export default React.memo(QuickRouting)